import { ajax } from "./communication/AjaxHelper";
import { LogoutRequest } from "./Data";

export class AutoLogout {

    logoutAfterMinutes: number = 25;
    counterInMinutes: number = this.logoutAfterMinutes;

    constructor() {
        let that = this;
        setInterval(() => {
            that.counterInMinutes--;
            // console.log("AutoLogout: " + that.counterInMinutes + " minutes left until logout.");
            if (that.counterInMinutes == 0) {
                that.logout();
            }
        }, 60 * 1000);

        document.body.addEventListener("keydown", () => {
            that.reset();
        });

        document.body.addEventListener("mousedown", () => {
            that.reset();
        })

    }

    reset() {
        this.counterInMinutes = this.logoutAfterMinutes;
    }


    logout() {
        let logoutRequest: LogoutRequest = {
            currentWorkspaceId: null
        }

        ajax('logout', logoutRequest, () => {
            window.location.href = 'index.html';
        });

    }

}